'use client';

import { BookOpen, Eye } from 'lucide-react';
import { Button } from '@/atoms/Button/Button';
import { Container } from '@/atoms/Container/Container';
import { cn } from '@/libs/utils/utils';
import { PassportLogin } from '../PassportLogin/PassportLogin';

interface ActionButtonsProps {
  className?: string;
  onLearn?: () => void;
  onExplore?: () => void;
}
/** Landing hero CTAs (Home v27): Log in through Passport, then Learn / Explore on phones. */
export function ActionButtons({ className, onLearn, onExplore }: ActionButtonsProps) {
  return (
    <Container className={cn('gap-4', className)}>
      <Container
        overrideDefaults
        className="relative z-10 flex w-full flex-col gap-3 sm:w-fit sm:flex-row sm:items-center"
        data-testid="action-buttons-primary"
      >
        <PassportLogin block className="w-full sm:w-fit" />
      </Container>
      {(onLearn || onExplore) && (
        <Container className="flex-row gap-3 md:hidden" data-testid="action-buttons-secondary">
          {onLearn && (
            <Button
              id="learn-btn"
              data-cy="learn-btn"
              variant="outline"
              className="flex-1 gap-2 backdrop-blur-sm"
              onClick={onLearn}
            >
              <BookOpen className="size-4" />
              {'Learn'}
            </Button>
          )}
          {onExplore && (
            <Button
              id="explore-btn"
              data-cy="explore-btn"
              variant="outline"
              className="flex-1 gap-2 backdrop-blur-sm"
              onClick={onExplore}
            >
              <Eye className="size-4" />
              {'Explore'}
            </Button>
          )}
        </Container>
      )}
    </Container>
  );
}
